import { useEffect, useState } from 'react';

import { EnumOption } from '../../modules/types/types';
import httpClient, { isHttpError } from '../httpClient';

export const useModuloUsuario = () => {
  const [moduloUsuario, setModuloUsuario] = useState<EnumOption[]>([]);

  useEffect(() => {
    const fetchModuloUsuario = async () => {
      try {
        const response = await httpClient.get(`/api/users/modulousuario`);

        // Transforma os dados da API no formato esperado
        const options = response.data.map(
          (moduloUsuario: { value: number; label: string }) => ({
            value: moduloUsuario.value.toString(),
            label: moduloUsuario.label,
          }),
        );
        setModuloUsuario(options);
      } catch (error) {
        if (isHttpError(error)) {
          console.error(
            'Erro ao buscar dados do Módulo Usuário:',
            error.response?.data?.message || error.message,
          );
        } else {
          console.error(
            'Erro inesperado ao buscar dados do Módulo Usuário:',
            error,
          );
        }
      }
    };

    fetchModuloUsuario();
  }, []);

  return moduloUsuario;
};
